import React, { useEffect, useState } from "react";
import { Table, Image, Select } from "antd";
import AddFeedModal from "../../../Components/AddFeedModal";
import { CreateButton } from "../category/Categories";
import {
  collection,
  collectionGroup,
  deleteDoc,
  doc,
  getDocs,
  limit,
  orderBy,
  query,
  startAfter,
  where,
  writeBatch,
} from "firebase/firestore";
import { db, storage } from "../../../firebase";
import { toast } from "react-toastify";
import styled from "styled-components";
import { DeleteIcon, EditIcon } from "../../../Utils/SvgIcons";
import DeleteModal from "../../../Components/modals/DeleteConfirm";
import { deleteObject, ref } from "firebase/storage";
const { Option } = Select;

const Dashboard = () => {
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const [deleteModalVisible, setDeleteModalVisible] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const fetchTotalCount = async () => {
    const querySnapshot = await getDocs(collection(db, "feeds"));
    setTotalCount(querySnapshot.size);
  };
  const columns = [
    {
      title: "S.No.",
      key: "index",
      render: (_, __, index) => (currentPage - 1) * pageSize + index + 1 + ".",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Image",
      dataIndex: "imageUrl",
      key: "imageUrl",
      render: (text) => <Image width={50} src={text} alt="Image" />,
    },
    {
      title: "Video URL",
      dataIndex: "videoUrl",
      key: "videoUrl",
      render: (text) => (
        <a href={text} target="_blank" rel="noopener noreferrer">
          View Video
        </a>
      ),
    },
    {
      title: "Capcut Link",
      dataIndex: "capcut_link",
      key: "capcut_link",
      render: (text) => (
        <p
          style={{
            color: "#5ea1ff",
            maxWidth: "100px",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          <a href={text} target="_blank" rel="noopener noreferrer">
            {text}
          </a>
        </p>
      ),
    },
    {
      title: "Whatsapp Link",
      dataIndex: "whatsapp_link",
      key: "whatsapp_link",
      render: (text) => (
        <p
          style={{
            color: "#5ea1ff",
            maxWidth: "100px",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          <a href={text} target="_blank" rel="noopener noreferrer">
            {text}
          </a>
        </p>
      ),
    },
    {
      title: "Telegram Link",
      dataIndex: "telegram_link",
      key: "telegram_link",
      render: (text) => (
        <p
          style={{
            color: "#5ea1ff",
            maxWidth: "100px",
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          <a href={text} target="_blank" rel="noopener noreferrer">
            {text}
          </a>
        </p>
      ),
    },
    {
      title: "Categories",
      dataIndex: "categories",
      key: "categories",
      render: (categories) => (categories || [])?.join(", "),
    },
    {
      title: "Actions",
      key: "actions",

      render: (_, record) => (
        <ActionBox>
          <button
            className="edit"
            onClick={() => {
              setSelectedFeed(record);
              setAddFeedModal(true);

              // openEditModal(record);
            }}
          >
            <EditIcon />
          </button>

          <button
            className="delete"
            onClick={() => {
              setSelectedFeed(record);
              setDeleteModalVisible(true);
              // handleDeleteFeed(record.id);
            }}
          >
            <DeleteIcon />
          </button>
        </ActionBox>
      ),
    },
  ];
  const [addFeedModal, setAddFeedModal] = useState(false);
  const [feeds, setFeeds] = useState([]);
  const [loading, setLoading] = useState(false);
  const [lastDoc, setLastDoc] = useState(null);
  const [selectedFeed, setSelectedFeed] = useState(null);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [categoryOptions, setCategories] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(false);

  const fetchFeeds = async (isNext = true, filters = []) => {
    setLoading(true);
    try {
      let q = collection(db, "feeds");

      if (filters.length > 0) {
        q = query(q, where("categories_name", "array-contains-any", filters));
      } else {
        q = query(q, orderBy("name"), limit(pageSize));
      }

      if (isNext && lastDoc) {
        q = query(q, startAfter(lastDoc), limit(pageSize));
      }

      const querySnapshot = await getDocs(q);
      const feedsList = querySnapshot.docs.map((doc) => ({
        key: doc.id,
        id: doc.id,
        name: doc.data()?.name,
        categories: doc.data()?.categories_name,
        imageUrl: doc.data()?.thumbnail,
        videoUrl: doc.data()?.video,
        capcut_link: doc.data()?.capcut_link,
        telegram_link: doc.data()?.telegram_link,
        whatsapp_link: doc.data()?.whatsapp_link,
      }));
      const lastVisible = querySnapshot.docs[querySnapshot.docs.length - 1];
      setLastDoc(lastVisible);
      setFeeds(feedsList);
    } catch (error) {
      console.error("Error fetching feeds", error);
    } finally {
      setLoading(false);
    }
  };

  const UpdatedAfterAdd = () => {
    fetchTotalCount();
    fetchFeeds(false);
  };

  const handleFilterChange = (values) => {
    setSelectedCategories(values);
    setCurrentPage(1);
    setLastDoc(null);
    fetchFeeds(false, values);
  };

  const handleTableChange = (pagination) => {
    const { current } = pagination;
    if (current > currentPage) {
      fetchFeeds(true, selectedCategories);
    } else {
      fetchFeeds(false, selectedCategories);
    }
    setCurrentPage(current);
  };

  const handleDeleteFeed = async () => {
    try {
      setDeleteLoading(true);
      if (selectedFeed?.imageUrl) {
        const imageRef = ref(storage, selectedFeed.imageUrl);
        await deleteObject(imageRef);
      }
      if (selectedFeed?.videoUrl) {
        const videoRef = ref(storage, selectedFeed.videoUrl);
        await deleteObject(videoRef);
      }
      await deleteDoc(doc(db, "feeds", selectedFeed?.id));
      const feedQuerySnapshot = await getDocs(
        query(
          collectionGroup(db, "feed_ids"),
          where("feed_id", "==", selectedFeed?.id)
        )
      );

      // 3. Batch Delete Feed from Each User's 'favorites'
      const batch = writeBatch(db);
      const usersToDeleteFrom = [];

      (feedQuerySnapshot || [])?.forEach((docSnap) => {
        if (docSnap?.id === selectedFeed?.id) {
          const pathSegments = docSnap.ref.path.split("/");
          const userId = pathSegments[1]; // Extract user ID from path -> "favorites/{userId}/feed_ids/{feedId}"
          usersToDeleteFrom.push(userId);

          // Add delete operation to batch
          batch.delete(docSnap.ref);
        }
      });

      if (usersToDeleteFrom?.length > 0) await batch.commit();

      toast.success("Feed deleted successfully!");
      fetchTotalCount();
      fetchFeeds(false);
      setDeleteModalVisible(false);
    } catch (error) {
      console.error("Error deleting Feed:", error);
      toast.error("Failed to delete Feed.");
    } finally {
      setDeleteLoading(false);
    }
  };

  const fetchCategories = async () => {
    setCategoryLoading(true);
    try {
      const querySnapshot = await getDocs(collection(db, "categories"));
      const categoryList = querySnapshot.docs.map((doc, index) => ({
        key: doc.id,
        id: doc.id,
        sNo: index + 1,
        name: doc.data().name,
        value: doc.data().name,
      }));
      setCategories(categoryList);
    } catch (error) {
      console.error("Error:", error);
      toast.error("Error fetching categories");
    } finally {
      setCategoryLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
    fetchTotalCount();
    fetchFeeds();
  }, []);

  return (
    <div style={{ marginTop: 20 }}>
      {addFeedModal && (
        <AddFeedModal
          isVisible={addFeedModal}
          onClose={() => setAddFeedModal(false)}
          fetchFeeds={UpdatedAfterAdd}
          feedToEdit={selectedFeed}
        />
      )}
      {deleteModalVisible && (
        <DeleteModal
          visible={deleteModalVisible}
          onConfirm={handleDeleteFeed}
          onCancel={() => setDeleteModalVisible(false)}
          loading={deleteLoading}
          itemName="this feed"
        />
      )}
      <div
        style={{
          width: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h2 style={{ textAlign: "start", fontFamily: "Poppins" }}>Feeds</h2>
        <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
          <Select
            mode="multiple"
            allowClear
            loading={categoryLoading}
            placeholder="Filter by Categories"
            style={{
              width: selectedCategories?.length > 1 ? 320 : 200,
            }}
            maxTagCount={2}
            value={selectedCategories}
            prefixCls="filter"
            onChange={handleFilterChange}
          >
            {categoryOptions.map((category, idx) => (
              <Option key={idx} value={category?.name}>
                {category?.name}
              </Option>
            ))}
          </Select>
          <CreateButton
            onClick={() => {
              setSelectedFeed(null);
              setAddFeedModal(true);
            }}
          >
            + Create
          </CreateButton>
        </div>
      </div>
      <Table
        columns={columns}
        dataSource={feeds}
        loading={loading}
        scroll={{ x: "auto" }}
        pagination={{
          current: currentPage,
          pageSize,
          total: totalCount,
        }}
        onChange={handleTableChange}
      />
    </div>
  );
};

export default Dashboard;

const ActionBox = styled.div`
  display: flex;
  gap: 10px;

  .edit {
    background: #28a3a9;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-style: none;
  }
  .delete {
    background: #fb4a49;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-style: none;
  }
`;
